/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import styled, {
  css,
  ThemeProvider,
  createGlobalStyle,
  useTheme as useStyledTheme,
  keyframes,
} from "styled-components";
import { JellyFishTheme } from "@centralwebteam/jellyfish";

declare module "styled-components" {
  export interface DefaultTheme extends JellyFishTheme {}
}

const _useThemeTypeOverriden = useStyledTheme as () => JellyFishTheme;

export {
  styled,
  css,
  ThemeProvider,
  createGlobalStyle,
  _useThemeTypeOverriden as useTheme,
  keyframes,
};
export default styled;
